import React from 'react'
import { useTranslation } from 'react-i18next'
import { ResultsLayout } from 'components/layout/ResultsLayout'
import { useSearchAndFilter } from 'components/SearchAndFilter/useSearchAndFilter'
import { useCustomersQuery } from 'hooks/queries/Customers/useCustomersQuery'
import { usePaginationWithApi } from 'hooks/usePaginationWithApi'
import { CustomerItems } from 'pages/Customers/CustomersList/CustomerItems'
import { CustomerModels } from 'pages/Customers/helpers/types'
import { Customer, CustomerStatus } from 'types/customers'

export const LiveCustomersList = () => {
  const { t } = useTranslation()

  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } =
    usePaginationWithApi()

  const { searchValue, appliedSearch, setSearchValue } = useSearchAndFilter('', {})

  const { data, isFetching, isError, refetch } = useCustomersQuery<Customer>({
    search: appliedSearch || undefined,
    page,
    size: rowsPerPage,
    filters: { statuses: [CustomerStatus.VERIFIED] },
  })

  const customers = data?.content ?? []
  const totalElements = data?.pagination?.total ?? 0

  return (
    <ResultsLayout
      testId="live-customers-results"
      isLoading={isFetching}
      isError={isError}
      hasResults={!!customers.length}
      hasSearchAndFilter={!!appliedSearch}
      searchAndFilter={{
        search: {
          placeholder: t('customers.searchPlaceholder'),
          value: searchValue,
          onChange: value => {
            setSearchValue(value)
            resetPage()
          },
        },
        filters: [],
      }}
      resetSearchAndFilters={() => {
        setSearchValue('')
        resetPage()
      }}
      refetchResults={refetch}
      emptyState={{
        dataName: 'customers',
        description: t('customers.description'),
      }}
      pagination={{
        page,
        rowsPerPage,
        total: totalElements,
        onChangePage: handleChangePage,
        onChangeRowsPerPage: handleChangeRowsPerPage,
      }}
    >
      <CustomerItems customerModel={CustomerModels.EMBEDDED} customers={customers} />
    </ResultsLayout>
  )
}
